import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  updateFlashBar,
  updateIsLoading,
  update_breadcrumb,
} from '../../redux/action';
import PageHeading from '../../components/PageHeading/PageHeading';
import { useNavigate, useParams } from 'react-router-dom';
import { colors } from '../../config/constants';
import Input from '../../components/Input/Input';
import Button from '../../components/Button/Button';
import Dailog from '../../components/Dailog/Dailog';
import axiosInstance from '../../service/axiosInstane';
import { flashBarTheme } from '../../config/flashBar';
import Dropdown from '../../components/Dropdown/Dropdown';
import { errorMessage } from '../../config/errorsMsg';
import { Role, RoleMapping } from '../../config/enum';
import { errorMessageAutoCapitalize } from '../../config/helpers';
import { StateProps } from '../../redux/reducer';
import { successMessage } from '../../config/keyword';

type GetUserResponse = {
  organizationId?: string;
  organizationRoleId?: string;
  organizationRoleName?: string;
  profileImage?: string;
  id: string;
  firstName: string;
  lastName: string;
  email?: string;
  role: number | string;
};

const UsersDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userInfo = useSelector((state: StateProps) => state.tokenInfo.userInfo);
  const [isUserEdit, setIsUserEdit] = useState(false);
  const [userDetail, setUserDetail] = useState<GetUserResponse>({
    id: '',
    firstName: '',
    lastName: '',
    email: '',
    role: '',
    organizationRoleName: '',
  });

  const [state, setState] = useState<GetUserResponse>({
    id: '',
    firstName: '',
    lastName: '',
    role: '',
    organizationRoleId: '',
  });
  const [formError, setFormError] = useState<any>({});
  const {
    firstName,
    lastName,
    email,
    role,
    organizationRoleName,
    organizationRoleId,
  } = userDetail;
  const [changePasswordTab, setChangePasswordTab] = useState(false);
  const [isDeletePopup, setIsDeletePopup] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [organizationRole, setOrganizationsRole] = useState([
    {
      id: '',
      name: '',
    },
  ]);
  const [changePassword, setChangePassword] = useState<{
    newPassword: string;
    confirmNewPassword: string;
  }>({
    newPassword: '',
    confirmNewPassword: '',
  });
  const [passwordError, setPasswordError] = useState<any>({});
  const { newPassword, confirmNewPassword } = changePassword;
  useEffect(() => {
    const breadcrumb = [
      { path: '/users', name: 'Users' },
      { path: `/userDetails/${id}`, name: 'User Details' },
    ];
    dispatch(update_breadcrumb(breadcrumb));
    getUserData();
    if (userInfo.role === Role.Admin) {
      getOrganizationRole();
    }

    localStorage.setItem('breadcrumbData', 'User');
  }, []);

  useEffect(() => {
    if (Object.keys(formError).length === 0 && isSubmit) {
      updateUser();
    }
  }, [formError]);

  useEffect(() => {
    if (Object.keys(passwordError).length === 0 && isSubmit) {
      updatePassword();
    }
  }, [passwordError]);

  const handleUpdate = () => {
    setFormError(validation());
    setIsSubmit(true);
  };

  const handleChangeText = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setUserDetail({ ...userDetail, [event.target.name]: event.target.value });
    if (event.target.value !== '' || Number(event.target.value) !== 0) {
      setFormError({ ...formError, [event.target.name]: undefined });
    } else {
      setFormError({
        ...formError,
        [event.target.name]: `${errorMessageAutoCapitalize(
          event.target.name
        )} is required  `,
      });
    }
  };

  const handleUpdateCancel = () => {
    getUserData();
    setIsUserEdit(false);
    setIsSubmit(false);
    setFormError({});
  };

  const validation = () => {
    const error: any = {};
    if (!firstName) {
      error.firstName = errorMessage.emptyFirstName;
    } else if (
      (firstName.length > 0 && firstName.length < 2) ||
      firstName.length > 64
    ) {
      error.firstName = errorMessage.userFirstNameLength;
    }
    if (!lastName) {
      error.lastName = errorMessage.emptyLastName;
    } else if (
      (lastName.length > 0 && lastName.length < 2) ||
      lastName.length > 64
    ) {
      error.lastName = errorMessage.userLastNameLength;
    }
    if (!role) {
      error.role = errorMessage.emptyRole;
    }
    if (role === Role.User) {
      if (!organizationRoleId) {
        error.organizationRoleId = errorMessage.emptyOrganizationRole;
      }
    }
    return error;
  };

  const onUserDelete = () => {
    dispatch(updateIsLoading(true));
    axiosInstance
      .delete(`/users/${id}`)
      .then((response) => {
        if (response.status === 200) {
          const obj = {
            isOpen: true,
            message: successMessage.USER_DELETE,
            type: flashBarTheme.SUCCESS,
          };
          dispatch(updateFlashBar(obj));
          setIsDeletePopup(false);
          navigate('/users');
          dispatch(updateIsLoading(false));
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  const getUserData = () => {
    dispatch(updateIsLoading(true));
    axiosInstance
      .get(`/users/${id}`)
      .then((response) => {
        if (response.status === 200) {
          gotResponce(response.data);
        }
      })
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .catch((_err) => {
        const obj = {
          isOpen: true,
          message: errorMessage.oops,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  const gotResponce = (data: GetUserResponse) => {
    setUserDetail(data);
    setState(data);
    dispatch(updateIsLoading(false));
  };

  const updateUser = () => {
    dispatch(updateIsLoading(true));
    const roleInt = parseInt(role as string);
    const obj = {
      firstName: firstName,
      lastName: lastName,
      role: roleInt,
      organizationRoleId: roleInt === Role.User ? organizationRoleId : null,
    };
    axiosInstance
      .put(`/users/${id}`, obj)
      .then((response) => {
        if (response.status === 200) {
          const obj = {
            isOpen: true,
            message: successMessage.USER_UPDATE,
            type: 'success',
          };
          dispatch(updateFlashBar(obj));
          getUserData();
          dispatch(updateIsLoading(false));
        }
      })
      .catch(() => {
        const obj = {
          isOpen: true,
          message: errorMessage.oops,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
    setIsUserEdit(false);
  };

  const getOrganizationRole = () => {
    dispatch(updateIsLoading(true));
    axiosInstance
      .get(`organizations/${userInfo.organizationId}/roles`)
      .then((response) => {
        if (response.status === 200) {
          setOrganizationsRole(
            response.data.map((item: GetUserResponse) => {
              return { id: item.id, name: item.role };
            })
          );
          dispatch(updateIsLoading(false));
        }
      })
      .catch(() => {
        dispatch(updateIsLoading(false));
        const obj = {
          isOpen: true,
          message: 'Something went wrong!',
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
      });
  };

  //change password
  const handleClick = () => {
    setPasswordError(passwordValidation());
    setIsSubmit(true);
  };

  const passwordValidation = () => {
    const error: any = {};
    if (!newPassword) {
      error.newPassword = errorMessage.emptyNewPassword;
    } else if (newPassword.length < 12 || newPassword.length > 38) {
      error.newPassword = errorMessage.passwordLength;
    }
    // else if (/[A-Z]/.test(newPassword) === false) {
    //   error.newPassword = 'At least 1 uppercase letter (A-Z)';
    // } else if (/[a-z]/.test(newPassword) === false) {
    //   error.newPassword = 'At least 1 lowercase letter (a-z)';
    // } else if (/[^a-zA-Z0-9]/.test(newPassword) === false) {
    //   error.newPassword = 'At least 1 special character';
    // } else if (/[0-9]/.test(newPassword) === false) {
    //   error.newPassword = 'At least 1 number (0-9)';
    // }

    if (!confirmNewPassword) {
      error.confirmNewPassword = errorMessage.emptyConfirmPassword;
    } else if (newPassword !== confirmNewPassword) {
      error.confirmNewPassword = errorMessage.passwordNotMatching;
    }
    return error;
  };

  const handlePasswordChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setChangePassword({
      ...changePassword,
      [event.target.name]: event.target.value,
    });

    if (event.target.value !== '') {
      setPasswordError({ ...passwordError, [event.target.name]: undefined });
    } else {
      setPasswordError({
        ...passwordError,
        [event.target.name]: `${event.target.name} is required`,
      });
    }
  };

  const updatePassword = () => {
    axiosInstance
      .put(`/users/${id}/password`, changePassword)
      .then((response) => {
        if (response.status === 200) {
          gotUpdatePasswordResponse(response.data);
        }
      })
      .catch(() => {
        const obj = {
          isOpen: true,
          message: errorMessage.oops,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
      });
  };

  const gotUpdatePasswordResponse = (data: {
    isSuccess: boolean;
    message: string;
  }) => {
    const { isSuccess, message } = data;

    if (!isSuccess) {
      const obj = {
        isOpen: true,
        message: message,
        type: flashBarTheme.ERROR,
      };
      dispatch(updateFlashBar(obj));
    } else {
      const obj = {
        isOpen: true,
        message: successMessage.PASSWORD_UPDATE,
        type: flashBarTheme.SUCCESS,
      };
      setChangePassword({ newPassword: '', confirmNewPassword: '' });
      dispatch(updateFlashBar(obj));
      setChangePasswordTab(!changePasswordTab);
    }
  };

  const passwordChangeCancel = () => {
    setChangePasswordTab(!changePasswordTab);
    setChangePassword({ newPassword: '', confirmNewPassword: '' });
    setPasswordError({});
    setIsSubmit(false);
  };
  const onClickUserActivity = () => {
    localStorage.setItem('isFrom', 'users');
    navigate(`/userActivity/${id}`);
  };
  return (
    <>
      <div className="px-2 py-1 ">
        <PageHeading label="User Details" />
        <div
          className={`flex flex-col justify-between ${colors.primaryText} rounded-sm p-5 bg-white `}
        >
          <div className="sm:flex text-md mb-2">
            <div className={`sm:w-1/3`}>First Name</div>
            {isUserEdit ? (
              <div className="-my-1">
                <Input
                  placeholder={'Enter First Name'}
                  type={'text'}
                  value={firstName}
                  name="firstName"
                  onChange={(event) => {
                    handleChangeText(event);
                  }}
                  error={formError?.firstName}
                />
              </div>
            ) : (
              <div className=" text-black flex sm:w-2/4 ">
                <div>{firstName}</div>
              </div>
            )}
          </div>
          <div className="sm:flex text-md mb-2">
            <div className={`sm:w-1/3 `}>Last Name</div>
            {isUserEdit ? (
              <div className="-my-1">
                <Input
                  placeholder={'Enter Last Name'}
                  type={'text'}
                  value={lastName}
                  name="lastName"
                  onChange={(event) => {
                    handleChangeText(event);
                  }}
                  error={formError?.lastName}
                />
              </div>
            ) : (
              <div className=" text-black flex sm:w-2/4 ">
                <div>{lastName}</div>
              </div>
            )}
          </div>

          <div className="sm:flex text-md mb-2">
            <div className={`sm:w-1/3 `}>Email</div>
            {isUserEdit ? (
              <div className="-my-1">
                <Input
                  placeholder={'Enter Email'}
                  type={'text'}
                  value={email}
                  name="email"
                  disabled={true}
                />
              </div>
            ) : (
              <div className=" text-black flex sm:w-2/4 ">
                <div>{email}</div>
              </div>
            )}
          </div>

          {isUserEdit && role === 1 ? null : (
            <div className="sm:flex text-md mb-2">
              <div className={`sm:w-1/3 `}>Type</div>
              {isUserEdit ? (
                <div className="-my-1">
                  <Dropdown
                    name={'role'}
                    value={role}
                    initialOption={{
                      name: 'Select Type',
                      id: '',
                    }}
                    options={[
                      { name: 'Admin', id: Role.Admin },
                      { name: 'User', id: Role.User },
                    ]}
                    onChange={(event) => {
                      handleChangeText(event);
                    }}
                    error={formError?.role}
                  />
                </div>
              ) : (
                <div className=" text-black flex sm:w-2/4 ">
                  <div>{RoleMapping[role as Role]}</div>
                </div>
              )}
            </div>
          )}
          {userInfo.role === Role.Admin && Number(role) === Role.User && (
            <div className="sm:flex text-md mb-2">
              <div className={`sm:w-1/3 `}>Role</div>
              {isUserEdit ? (
                <div className="-my-1">
                  <Dropdown
                    name={'organizationRoleId'}
                    value={organizationRoleId}
                    initialOption={{
                      name: 'Select role',
                      id: '',
                    }}
                    options={organizationRole}
                    onChange={(event) => {
                      handleChangeText(event);
                    }}
                    error={formError?.organizationRoleId}
                  />
                </div>
              ) : (
                <div className=" text-black flex sm:w-2/4 ">
                  <div>
                    {organizationRoleName === null ? '-' : organizationRoleName}
                  </div>
                </div>
              )}
            </div>
          )}
          <div
            className={`flex items-center ${
              userInfo.role === Role.SuperAdmin ? 'justify-between' : 'justify-end'
            } `}
          >
            {userInfo.role === Role.SuperAdmin && (
              <div>
                <Button
                  label="Change Password"
                  buttonType="danger"
                  type="button"
                  onClick={() => passwordChangeCancel()}
                />
              </div>
            )}
            {isUserEdit ? (
              <div>
                <div className="flex justify-end space-x-2 mb-2">
                  <Button
                    label="Update"
                    buttonType="primary"
                    type="button"
                    onClick={() => handleUpdate()}
                    disabled={
                      (firstName === state.firstName &&
                        lastName === state.lastName &&
                        Number(role) === state.role &&
                        organizationRoleId === state.organizationRoleId) ||
                      organizationRoleId === ''
                    }
                  />

                  <Button
                    label="Cancel"
                    buttonType="danger"
                    type="button"
                    onClick={() => handleUpdateCancel()}
                  />
                </div>
              </div>
            ) : (
              <div
                className={`flex items-center space-x-2 ${
                  userInfo.role === Role.SuperAdmin
                    ? 'justify-between'
                    : 'justify-end'
                }`}
              >
                <div className="flex items-center space-x-2 justify-end w-full">
                  <Button
                    label="User Activity"
                    buttonType="primary"
                    type="button"
                    onClick={onClickUserActivity}
                  />

                  <Button
                    label="Edit"
                    buttonType="primary"
                    type="button"
                    onClick={() => setIsUserEdit(true)}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {changePasswordTab && (
        <div className="shadow-sm rounded-sm px-2 mt-5">
          <PageHeading label="Change Password" color={'#000'} />
          <div className={`${colors.primaryText} p-4 bg-white rounded-xl`}>
            <div className="w-full">
              <div className="lg:flex items-center lg:space-x-8">
                <Input
                  label="New Password"
                  type="password"
                  placeholder="Enter a new password"
                  value={newPassword}
                  name="newPassword"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    handlePasswordChange(e)
                  }
                  error={passwordError?.newPassword}
                />
                <Input
                  label="Confirm Password"
                  type="password"
                  placeholder="Re-enter new password"
                  value={confirmNewPassword}
                  name="confirmNewPassword"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    handlePasswordChange(e)
                  }
                  error={passwordError?.confirmNewPassword}
                />
              </div>
              <div className="flex justify-start mt-6">
                <div className="mr-4">
                  <Button
                    label={'submit'}
                    type={'button'}
                    buttonType={'warning'}
                    onClick={() => handleClick()}
                  />
                </div>
                <div>
                  <Button
                    label={'cancel'}
                    type={'button'}
                    buttonType={'danger'}
                    onClick={() => passwordChangeCancel()}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="flex justify-center pt-8">
        <Button
          label="Delete User"
          buttonType="danger"
          type="button"
          onClick={() => setIsDeletePopup(true)}
        />

        <Dailog
          isDeletePopup={isDeletePopup}
          setIsPopupOpen={setIsDeletePopup}
          title={'User'}
          onConfirm={() => {
            onUserDelete();
          }}
        />
      </div>
    </>
  );
};
export default UsersDetails;
